const Promo = require('./dist/promo/Promo');
const ShareTools = require('./dist/share-tools');

module.exports = {
  Promo,
  ShareTools,
};
